import { schema } from 'normalizr';

export const labelReviewClaimSchema = new schema.Entity('labelReviewClaims', {}, { idAttribute: 'LabelReviewClaimId' });
export const labelReviewClaimListSchema = [labelReviewClaimSchema];
